import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ setActiveTab }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 1,
      title: "My Products",
      description: "Manage your existing products",
      icon: "List",
      variant: "default",
      onClick: () => setActiveTab('products')
    },
    {
      id: 2,
      title: "My Components",
      description: "Manage your existing components",
      icon: "Box",
      variant: "outline",
      onClick: () => setActiveTab('components')
    },
    {
      id: 3,
      title: "Orders",
      description: "View and process customer orders",
      icon: "Clock",
      variant: "secondary",
      onClick: () => setActiveTab('orders')
    },
    {
      id: 4,
      title: "Upload Model",
      description: "Share your 3D creations",
      icon: "Upload",
      variant: "success",
      path: "#" // This can be updated to a real path later
    },
  ];

  const renderAction = (action) => {
    const content = (
      <div className="p-4 rounded-lg border border-border hover:border-primary/50 hover:bg-muted/30 transition-smooth group">
        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-smooth">
            <Button
              variant="ghost"
              size="icon"
              iconName={action?.icon}
              className="w-5 h-5 text-primary"
            />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-foreground group-hover:text-primary transition-smooth">
              {action?.title}
            </h3>
            <p className="text-xs text-muted-foreground mt-1">
              {action?.description}
            </p>
          </div>
        </div>
      </div>
    );

    // Render Link if action has path, otherwise render clickable div with onClick
    if (action?.path) {
      return (
        <Link key={action?.id} to={action?.path} className="block">
          {content}
        </Link>
      );
    } else if (action?.onClick) {
      return (
        <div 
          key={action?.id} 
          onClick={action?.onClick} 
          className="block cursor-pointer"
        >
          {content}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-soft">
      <h2 className="text-xl font-semibold text-foreground mb-6">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => renderAction(action))}
      </div>
    </div>
  );
};

export default QuickActions;